/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Not_Found_TitleInputs */

const en_apartment_not_found_title = /** @type {(inputs: Apartment_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment not found`)
};

/**
* | output |
* | --- |
* | "Apartment not found" |
*
* @param {Apartment_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_not_found_title = /** @type {((inputs?: Apartment_Not_Found_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Not_Found_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_not_found_title(inputs)
});